import { ACTIONS } from './connectionUtils'

interface storageProduct {
  id?: number
  product: number
  product_name?: string
  quantity: number
}

interface tupper {
  id?: number
  recipe: number
  recipe_name?: string
  quantity: number
}

interface StorageResponse {
  success: boolean
  products?: storageProduct[]
  tuppers?: tupper[]
  error?: string
}

async function getStorage(user: string): Promise<StorageResponse> {
  try {
    const response = await fetch('/api/storage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: StorageResponse = await response.json()
    return data
  } catch (error) {
    console.error('Storage error:', error)
    throw error
  }
}

async function insertStorageItem(
  user: string,
  product?: storageProduct,
  tupper?: tupper
) {
  try {
    const response = await fetch('/api/storage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.INSERT,
        user,
        product,
        tupper,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function updateStorageItem(
  user: string,
  product?: storageProduct,
  tupper?: tupper
) {
  try {
    const response = await fetch('/api/storage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.UPDATE,
        user,
        product,
        tupper,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Product error:', error)
    throw error
  }
}

async function completeRecipe(user: string, recipe: number, tuppers: number) {
  try {
    const response = await fetch('/api/storage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.COMPLETE,
        user,
        recipe,
        tuppers,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('Recipe error:', error)
    throw error
  }
}

export { getStorage, insertStorageItem, updateStorageItem, completeRecipe }
export type { storageProduct, StorageResponse, tupper }
